import format from "string-template";
import Card from "./Card";

const RadianceEmailTemplate = ({
  lastName,
  firstName,
  translation,
  costs,
  adminPhoneNumber,
  adminEmail,
  adminFirstName,
  adminLastName,
  adminAddress,
}) => {
  return (
    <div className="quote-template__main-container">
      <div className="quote-template__header">
        <img
          src="https://www.mutuelle-familiale.fr/themes/custom/tailwindcss/public/build/images/logo-lmf.svg"
          alt="La Mutuelle Familiale Logo"
        />
      </div>
      <div className="quote-template__container">
        <div className="quote-template__content">
          <p>{format(translation.HEADER, { firstName, lastName })}</p>
          <div className="quote-template__product-card--container">
            {costs?.map(({ id, insurancePlan, cost, currency }) => (
              <Card
                key={id}
                icon={insurancePlan?.icon}
                name={insurancePlan?.name}
                cost={cost}
                currency={currency}
                period={translation.CARD.PER_MONTH}
                perYear={translation.CARD.PER_YEAR}
                allIncluded={translation.CARD.ALL_INCLUDED}
                link={translation.CARD.LINK}
              />
            ))}
          </div>

          <div className="quote-template__info">
            <p className="quote-template__info--text">
              <span>{translation.YOUR_ADVISOR}</span>
            </p>
            <p className="quote-template__info--name">
              {adminFirstName} {adminLastName}
            </p>
            <p>{translation.NAME_ORGANIZATION}</p>
            <p>{adminEmail}</p>
            <p>{adminPhoneNumber}</p>
            <p>{adminAddress}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RadianceEmailTemplate;
